import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "@material/mwc-tab-bar/mwc-tab-bar.js";
import "@material/mwc-tab/mwc-tab.js";
import "@material/mwc-textfield/mwc-textfield.js";
import AdminDashboard from "./admindashboard";
import CancelAppointment from "./cancelAppointment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { format, parse, startOfMonth} from 'date-fns';
import { Pagination } from "react-bootstrap";

const formatDateForDisplay = (date) => format(date, "dd/MMM/yyyy hh:mm:ss a");

function Financials() {
  const [loading, setLoading] = useState(false);
  const [userPayments, setUserPayments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
     const [currentPage, setCurrentPage] = useState(0);
      const [totalPages, setTotalPages] = useState(0);
  const [filter, setFilter] = useState("ALL");
  const [fromDate, setFromDate] = useState(formatDateForDisplay(startOfMonth(new Date())));
const [toDate, setToDate] = useState(formatDateForDisplay(new Date()));


  const navigate = useNavigate();

  const getData = async (pageNumber=0) => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const response = await axios.post(
        `/api/user/userpayment/payments`,
        {
          fromDate,
          toDate
        },
          {
            params: { page: pageNumber},
            headers: { Authorization: `Bearer ${token}` },
          });
          setUserPayments(response.data.content);
          setCurrentPage(response.data.number);
          setTotalPages(response.data.totalPages);
          
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const searchData = async (pageNumber=0) => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const requestData = {
        searchTerm,
        fromDate,
        toDate, 
        status: filter === "ALL" ? null : filter,
      };
      const response = await axios.post(
        `/api/user/userpayment/searchPayments`, requestData,
        {
          params: { page: pageNumber},
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserPayments(response.data.content);
        setCurrentPage(response.data.number);
        setTotalPages(response.data.totalPages);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setCurrentPage(0); // Reset to first page on search, filter, or date change
  }, [searchTerm, filter, fromDate, toDate]);
  
  useEffect(() => {
    searchData(currentPage);
  }, [searchTerm, filter, currentPage, fromDate, toDate]);


  const [selectedPayment, setSelectedPayment] = useState(null);
  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
  const handleCancelClick = async (payment) => {
    setSelectedPayment(payment);
    setIsCancelPopupOpen(true);
  };

  const handleCloseCancelPopup = () => {
    setIsCancelPopupOpen(false);
    searchData(currentPage);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }


  return (
    <div>
      <div>
        <AdminDashboard />
      </div>

      {loading && <div className="loading"></div>}

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10">
        <div className="card card-raised">
          <div className="card-body">
            <div className="card-title form-group d-flex align-items-center justify-content-between mb-4">
              <span>Payment Details</span>
            </div>

            <div className="d-flex align-items-center mb-3 flex-wrap">
              <div className="position-relative me-3 flex-grow-1">
                <input
                  type="search"
                  className="form-control pl-4"
                  placeholder="Search by company name and user name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ paddingLeft: "2rem", width: "60%" }} // Ensure the input takes the full width of the parent div
                />
                <span className="position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}>
                  <FontAwesomeIcon icon={faSearch} />
                </span>
              </div>
              <div className="me-3">
                <label>Filter By Status</label>
                <select
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  className="form-select"
                >
                  <option value="ALL">ALL</option>
                  <option value="SUCCESS">PAYMENT SUCCESS</option>
                  <option value="PAYMENT PROCESSED">PAYMENT PROCESSED</option>
                  <option value="REFUND PROCESSED">REFUND PROCESSED</option>
                </select>
              </div>
              <div className="me-3">
  <label>From Date</label>
  <input
    type="date"
    value={fromDate ? format(parse(fromDate, 'dd/MMM/yyyy hh:mm:ss a', new Date()), 'yyyy-MM-dd') : ''}
    onChange={(e) => setFromDate(formatDateForDisplay(parse(e.target.value, 'yyyy-MM-dd', new Date())))}
    className="form-control"
  />
</div>

<div>
  <label>To Date</label>
  <input
    type="date"
    value={toDate ? format(parse(toDate, 'dd/MMM/yyyy hh:mm:ss a', new Date()), 'yyyy-MM-dd') : ''}
    onChange={(e) => setToDate(formatDateForDisplay(parse(e.target.value, 'yyyy-MM-dd', new Date())))}
    className="form-control"
  />
</div>

            </div>

            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Sl.No.</th>
                    <th>Company Name</th>
                    <th>Employee Name</th>
                    <th>Date</th>
                    <th>Payment Id</th>
                    <th>Amount</th>
                    <th>Payment Status</th>
                  </tr>
                </thead>
                <tbody>
                {userPayments.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  ) : (
                    userPayments.map((payment, index) => {
                      return (
                        <tr key={index}>
                          <td>{index+1}</td>
                          <td>{payment.company?.companyname}</td>
                          <td>
                            <div>
                              {payment.employee?.name} &nbsp;
                              {payment.employee?.lastname}
                            </div>
                            <div style={{ fontSize: '14px', color: '#999' }}>
                            {payment.memberName}
                              </div>
                          </td>
                          <td>{payment.paymentdate}</td>
                          <td>{payment.razorpay_payment_id}</td>
                          <td>{payment.paymentAmount} ₹</td>
                          <td>
                            <div>{payment.paymentStatus}</div>
                            {payment.paymentStatus === "PAYMENT PROCESSED" && payment.appointmentStatus !== "APPOINTMENT COMPLETED" && (
                              <div
                                style={{
                                  display: "inline-block",
                                  padding: "0.25em 0.5em",
                                  borderRadius: "10px",
                                  backgroundColor: "red",
                                  color: "white",
                                  border: "1px solid #c3e6cb",
                                  marginTop: "0.5em",
                                  cursor: "pointer",
                                }}
                                title="Cancel Appointment"
                                onClick={() => handleCancelClick(payment)}
                              >
                                REFUND
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>

            {isCancelPopupOpen && (
              <CancelAppointment
              isOpen={isCancelPopupOpen}
                onRequestClose={handleCloseCancelPopup}
                payment={selectedPayment}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Financials;